const FIVE_MINUTES = 5 * 60_000;
let activeRunner = null;

export const startPresenceHeartbeat = (send, environment = {}) => {
  if (activeRunner) {
    activeRunner.references += 1;
    activeRunner.send = send;
    return () => activeRunner?.release();
  }
  const doc = environment.document || document;
  const timer = environment.timer || window;
  const now = environment.now || Date.now;
  const runner = { references: 1, send, inFlight: null, lastSent: -Infinity };
  const ping = () => {
    if (doc.hidden || runner.inFlight || now() - runner.lastSent < 1000) return;
    runner.lastSent = now();
    runner.inFlight = Promise.resolve().then(() => runner.send())
      .catch(() => {})
      .finally(() => { runner.inFlight = null; });
  };
  let interval = null;
  const onVisibility = () => {
    if (doc.hidden) {
      if (interval !== null) timer.clearInterval(interval);
      interval = null;
    } else {
      ping();
      if (interval === null) interval = timer.setInterval(ping, FIVE_MINUTES);
    }
  };
  doc.addEventListener("visibilitychange", onVisibility);
  onVisibility();
  runner.release = () => {
    runner.references -= 1;
    if (runner.references > 0) return;
    if (interval !== null) timer.clearInterval(interval);
    doc.removeEventListener("visibilitychange", onVisibility);
    activeRunner = null;
  };
  activeRunner = runner;
  return () => runner.release();
};
